import { Snackbar, Alert } from "@mui/material";

const SnackbarAlert = ({ feedback, duration = 3000, onClose }) => {
  return (
    <>
      <Snackbar
        open={feedback.open}
        autoHideDuration={duration}
        onClose={onClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ marginTop: "60px" }}
      >
        <Alert
          onClose={onClose}
          severity={feedback.severity}
          sx={{
            width: "100%",
            p: "16px 20px", // Bigger padding
            fontSize: "1.1rem", // Bigger text
            "& .MuiAlert-message": {
              fontSize: "1.1rem",
            },
            "& .MuiAlert-icon": {
              fontSize: "2rem", // Bigger icon
            },
          }}
        >
          {feedback.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SnackbarAlert;
